// extracted by mini-css-extract-plugin
export default {"cta":"y_kRkf1r0ARne8JD36Pn","ctaNoBorder":"MOmovijDBWajhsDRgsMG","ctaNoPadding":"fQaRQ9i8gE6Gj3vbAfYF"};